import { render, staticRenderFns } from "./mailingList.vue?vue&type=template&id=47503afe&scoped=true&"
import script from "./mailingList.vue?vue&type=script&lang=js&"
export * from "./mailingList.vue?vue&type=script&lang=js&"
import style0 from "./mailingList.vue?vue&type=style&index=0&id=47503afe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47503afe",
  null
  
)

export default component.exports